import { h } from "@stencil/core";
import { ChartState } from "../interfaces/chart-state";

export const DonutChartWrapper = (props, children) => {
    const showNoData =
        props.state === ChartState.NODATA ||
        (props.state !== ChartState.LOADING && props.noDataAvailable);
    return (
        <div id={props.chartId} class={`uic-donut-chart  ${props.rootClass}`}>
            {props.state == ChartState.LOADING && (
                <div class="uic-donut-chart__loading_indicator">
                    <uic-loader></uic-loader>
                </div>
            )}
            {showNoData && (
                <div class="uic-donut-chart__no-data-indicator">
                    <div>{props.noDataText}</div>
                </div>
            )}
            {props.size && (
                <svg
                    style={{
                        visibility: showNoData ? "hidden" : "inherit",
                    }}
                    width="100%"
                    height={`${props.size.height}px`}
                >
                    <g
                        class="uic-donut-chart__chart-area"
                        transform={`translate(${props.size.width / 2},${
                            props.size.height / 2
                        })`}
                    >
                        {children}
                    </g>
                </svg>
            )}
        </div>
    );
};
